window.addEventListener("load", () => {
  function scrollThumbOnly(index) {
    const thumbsInner = document.querySelector(".pdp-carousel-thumbnails-inner");
    if (!thumbsInner) return;

    const items = thumbsInner.querySelectorAll(".product-thumbnails__item");
    const el = items[index];
    if (!el) return;

    const target =
      el.offsetLeft - thumbsInner.clientWidth / 2 + el.offsetWidth / 2;

    thumbsInner.scrollTo({ left: Math.max(0, target), behavior: "smooth" });
  }

  var swiper = new Swiper(".product-swiper-container", {
    slidesPerView: 1,
    spaceBetween: 100,
    loop: false,
    autoplay: false,
    pagination: {
      el: ".product-thumbnails-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return (
          '<div class="' +
          className +
          ' product-thumbnails__item" data-index="' +
          index +
          '">' +
          document.querySelectorAll(".product-thumbnails__item img")[index].outerHTML +
          "</div>"
        );
      },
    },
    navigation: {
      nextEl: ".pdp-carousel-arrow-next",
      prevEl: ".pdp-carousel-arrow-prev",
    },
  });

  document.querySelectorAll(".product-thumbnails__item").forEach((element, index) => {
    element.addEventListener("click", () => {
      swiper.slideTo(index);
      scrollThumbOnly(index);
    });
  });

  swiper.on("slideChange", () => {
    let currentIndex = swiper.realIndex;

    document.querySelectorAll(".product-thumbnails__item").forEach((el, i) => {
      el.classList.toggle("active", i === currentIndex);
    });

    scrollThumbOnly(currentIndex);
  });

  const first = document.querySelector(".product-thumbnails__item");
  if (first) first.classList.add("active");
  scrollThumbOnly(0);

  document.querySelectorAll(".engraving_line")?.forEach((engr) => {
    engr.addEventListener("keyup", function () {
      swiper.slideTo(swiper.slides.length - 1);
    });
  });
});